import { __extends } from "tslib";
import { FederatedEvent } from './FederatedEvent';
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/Events/Creating_and_triggering_events
 *
 * @example
  const event = new CustomEvent('build', { detail: { prop1: 'xx' } });
  circle.addEventListener('build', (e) => {
    e.target; // circle
    e.detail; // { prop1: 'xx' }
  });

  circle.dispatchEvent(event);
 */

var CustomEvent =
/** @class */
function (_super) {
  __extends(CustomEvent, _super); // eslint-disable-next-line @typescript-eslint/ban-types


  function CustomEvent(eventName, object) {
    var _this = _super.call(this, null) || this;

    _this.type = eventName;
    _this.detail = object; // compatible with G 3.0

    Object.assign(_this, object);
    return _this;
  }

  return CustomEvent;
}(FederatedEvent);

export { CustomEvent };